import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledSnackbar = styled(Snackbar)({
  '& .MuiAlert-root': {
    backgroundColor: '#1a1a1a',
    color: '#fff',
    borderRadius: 0,
    fontFamily: 'Cormorant Garamond, serif',
    '& .MuiAlert-icon': {
      color: '#c4a661',
    },
  },
});

const StyledAlert = styled(Alert)({
  width: '100%',
  alignItems: 'center',
  '& .MuiAlert-message': {
    padding: '8px 0',
    fontSize: '1rem',
  },
});

const Notification = ({ 
  open, 
  message, 
  onClose, 
  severity = 'success', 
  autoHideDuration = 3000 
}) => {
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    if (onClose) {
      onClose(event, reason);
    }
  };

  return (
    <StyledSnackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <StyledAlert
        onClose={handleClose}
        severity={severity}
        variant="filled"
      >
        {message}
      </StyledAlert>
    </StyledSnackbar>
  );
};

export default Notification;
